import { useAppDispatch, useAppSelector } from '../../app/store'
import { toggleThemeMode } from '../../app/uiSlice'

export default function ThemeToggle() {
  const dispatch = useAppDispatch()
  const isDark = useAppSelector((s) => s.ui.themeMode === 'dark')

  return (
    <button
      onClick={() => dispatch(toggleThemeMode())}
      title={isDark ? 'تفعيل الوضع الفاتح' : 'تفعيل الوضع الداكن'}
      style={{
        position: 'relative',
        display: 'inline-flex',
        alignItems: 'center',
        width: 56,
        height: 28,
        borderRadius: 999,
        border: 'none',
        cursor: 'pointer',
        padding: 0,
        outline: 'none',
        flexShrink: 0,
        background: isDark
          ? 'linear-gradient(135deg,#1E2233 0%,#2A2D41 100%)'
          : 'linear-gradient(135deg,#c5d6f0 0%,#e8f0fb 100%)',
        boxShadow: isDark
          ? 'inset 0 0 0 1.5px #36394F, 0 2px 8px rgba(0,0,0,0.4)'
          : 'inset 0 0 0 1.5px #d0daea, 0 2px 8px rgba(0,0,0,0.08)',
        transition: 'all 0.35s cubic-bezier(.4,0,.2,1)',
      }}
    >
      {/* ─── Sun icon (light) ─── */}
      <span
        style={{
          position: 'absolute',
          left: 6,
          fontSize: 13,
          lineHeight: 1,
          opacity: isDark ? 0.35 : 1,
          transform: isDark ? 'scale(0.7) rotate(-30deg)' : 'scale(1) rotate(0deg)',
          transition: 'all 0.35s cubic-bezier(.4,0,.2,1)',
          userSelect: 'none',
        }}
      >
        ☀️
      </span>

      {/* ─── Moon icon (dark) ─── */}
      <span
        style={{
          position: 'absolute',
          right: 6,
          fontSize: 13,
          lineHeight: 1,
          opacity: isDark ? 1 : 0.35,
          transform: isDark ? 'scale(1) rotate(0deg)' : 'scale(0.7) rotate(30deg)',
          transition: 'all 0.35s cubic-bezier(.4,0,.2,1)',
          userSelect: 'none',
        }}
      >
        🌙
      </span>

      {/* ─── Slider knob ─── */}
      <span
        style={{
          position: 'absolute',
          top: 3,
          left: isDark ? 'calc(100% - 25px)' : 3,
          width: 22,
          height: 22,
          borderRadius: '50%',
          background: isDark
            ? 'linear-gradient(135deg,#8BB4D9 0%,#5a8db5 100%)'
            : 'linear-gradient(135deg,#ffffff 0%,#f0f4ff 100%)',
          boxShadow: isDark ? '0 2px 6px rgba(0,0,0,0.5)' : '0 2px 6px rgba(0,0,0,0.15)',
          transition: 'all 0.35s cubic-bezier(.4,0,.2,1)',
          flexShrink: 0,
          zIndex: 1,
        }}
      />
    </button>
  )
}
